import React from 'react';
import BaseNav from '@shared/components/common/BaseNav';
import OrgManager from '@shared/components/orgs/OrgManager';
import { useAuth } from '@shared/contexts/AuthContext';
import FloatingNav from '@/components/common/FloatingNav';

export default function OrgPage() {
  const { user } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <BaseNav />
      <div className="mt-14 flex-1 px-4 py-8 md:px-6">
        <OrgManager currentUserId={user?.user_id ?? ''} />
      </div>
      <FloatingNav />
    </div>
  );
}
